export const omit = <T extends object>(obj: T, ...props: (keyof T)[]) => {
  if (!obj) return obj;

  obj = { ...obj };
  for (const propName of props) {
    delete obj[propName];
  }
  return obj;
};
